
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(1013),
  areaId: Number,
  areaType: Number.withConstraint(x => x >= -1 && x <= 1000),
  attackerAllianceId: Number.withConstraint(x => x >= -2),
  attackerId: Number,
  battleLogId: Number.withConstraint(x => x >= 1),
  castleOwnerId: Number,
  defenderAllianceId: Number.withConstraint(x => x >= -2),
  mapId: Number.withConstraint(x => x >= -1 && x <= 1000),
  outcome: String.withConstraint(x => x.length <= 40),
}).And(Partial({
  attackerLevel: Number.withConstraint(x => x >= -1 && x <= 10000),
  defenderLevel: Number.withConstraint(x => x >= -1 && x <= 10000),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(1013),
  areaId: Number,
  areaType: Number.withConstraint(x => x >= -1 && x <= 1000),
  attackerAllianceId: Number.withConstraint(x => x >= -2),
  attackerId: Number,
  battleLogId: Number.withConstraint(x => x >= 1),
  castleOwnerId: Number,
  defenderAllianceId: Number.withConstraint(x => x >= -2),
  mapId: Number.withConstraint(x => x >= -1 && x <= 1000),
  outcome: String.withConstraint(x => x.length <= 40),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  zoneId: Number.withConstraint(x => x >= 1 && x <= 1000),
}).And(Partial({
  attackerLevel: Number.withConstraint(x => x >= -1 && x <= 10000),
  defenderLevel: Number.withConstraint(x => x >= -1 && x <= 10000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 1013;
  